export const AccountExpenseTypes = {
    SHOW_EXPENSE: "SHOW_EXPENSE",
    ADD_EXPENSE: "ADD_EXPENSE",
    UPDATE_EXPENSE: "UPDATE_EXPENSE",
    DELETE_EXPENSE: "DELETE_EXPENSE",
};
  